import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://zlicpjhdbgzgkzercuix.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpsaWNwamhkYmd6Z2t6ZXJjdWl4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU3NzIyNjIsImV4cCI6MjA4MTM0ODI2Mn0.XGQd5b52mXIrNweR1s_-8L-SIkusdMW0MA5rTnOgvGM';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});